
    import Vue from 'vue';

    export default Vue.extend({        
        head: {
			title: { inner: 'Find a Tennis Hit', separator: '|', complement: 'Str8 Sets Matcha' },
            meta: [
				{ name: 'description', content: 'Finding a hit of tennis at your skill level is easy. Matcha is a unique skill-based ranking system that allows you to meet people at your level. Download Str8 Sets to your device and find a hit of tennis today.', id: 'desc'},
                { property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'https://www.str8sets.com/tennis_find_a_hit_matcha' },
                { property: 'og:title', content: 'Find a Tennis Hit | Str8 Sets Matcha' },
                { property: 'og:description', content: 'Finding a hit of tennis at your skill level is easy. Matcha is a unique skill-based ranking system that allows you to meet people at your level. Download Str8 Sets to your device and find a hit of tennis today.' },
                { property: 'og:image', content: 'https://www.str8sets.com/img/meta_str8sets_tennis_matcha_1200x628.jpg' },   
				{ property: 'og:image:alt', content: 'Str8 Sets Tennis Logo and Matcha Screenshots' },            
                { name: 'twitter:site', content: 'str8sets' },
				{ name: 'twitter:creator', content: '@str8sets' },
				{ name: 'twitter:card', content: 'summary_large_image' },  
				{ name: 'twitter:url', content: 'https://www.str8sets.com/tennis_find_a_hit_matcha' },
				{ name: 'twitter:title', content: 'Find a Tennis Hit | Str8 Sets Matcha' },
                { name: 'twitter:description', content: 'Finding a hit of tennis at your skill level is easy. Matcha is a unique skill-based ranking system that allows you to meet people at your level. Download Str8 Sets to your device and find a hit of tennis today.' },
				{ name: 'twitter:image', content: 'https://www.str8sets.com/img/meta_str8sets_tennis_matcha_1200x628.jpg' },
				{ name: 'twitter:image:alt', content: 'Str8 Sets Tennis Logo and Matcha Screenshots' }
            ],
            link: [
      			{ rel: 'canonical', href: 'https://www.str8sets.com/tennis_find_a_hit_matcha', id: 'canonical' }
			]
        }
    })
